import React from "react";
import SelectCountyForm from "./SelectCountyForm";

const SelectCountyFormSelect = (props) => {
  return <SelectCountyForm {...props} />;
};

export default SelectCountyFormSelect;
